import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'select', 'checkbox' ]

  connect() {
    if (this.hasSelectTarget) {
      new Choices(this.selectTarget, {shouldSort: false});
    }
  }

  validateSelect(event) {
    document.querySelectorAll(".select-input").forEach((selectField) => {
      if (selectField.value.length > 0) {
        document.getElementById('submit').disabled = false;
      } else {
        document.getElementById('submit').disabled = true;
      }
    })
  }
}